import React from 'react'
import classNames from 'classnames'
import { FulfillmentOutlet } from '../types'

interface Props {
  outlets: FulfillmentOutlet[]
  className?: string
  onOutletChange: (outlet: string) => void
  currentOutlet: string
}

export const OutletToFulfilFrom: React.FC<Props> = ({
  outlets,
  className,
  onOutletChange,
  currentOutlet,
}) => {
  return (
    <div className={classNames('outlet-to-fulfil-from', className)}>
      <h4 className="vd-text-label">Outlet to fulfill from</h4>
      <select
        className="vd-select vd-mt2"
        onChange={e => {
          onOutletChange(e.currentTarget.value)
        }}
        defaultValue={currentOutlet}
      >
        {outlets.map(outlet => (
          <option key={outlet.id} value={outlet.id}>
            {outlet.name}
          </option>
        ))}
      </select>
    </div>
  )
}

OutletToFulfilFrom.displayName = 'OutletToFulfilFrom'
